<div class="view-container">
	<jepto-page-editor
		[initialPages]="editorPages()"
		[selectedPageId]="selectedPageIdSignal()"
		[themeConfig]="effectiveThemeConfig()"
		[viewOnly]="viewOnly()"
		[loading]="loading()"
		[contentBackground]="loading() ? 'transparent' : 'default'"
		(pageChangeById)="selectPageById($event)"
	>
		<div class="content-section">
			<div *ngIf="loading()" @fadeIn class="loading-container">
				<div class="loader">
					<div class="loader-bars">
						<span></span>
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>

			<div *ngIf="error() && !loading()" class="error-state">
				<p class="error-message">Error: {{ error() }}</p>
			</div>

			<div
				*ngIf="currentPage && !loading() && !error()"
				@contentFadeIn
				class="page-container"
			>
				<div *ngIf="pageLoading()" class="page-loading-overlay">
					<div class="spinner"></div>
					<p>Loading page content...</p>
				</div>

				<jepto-page-container
					[pageConfig]="currentPage"
					[viewId]="viewConfig()?.viewId"
					[accountId]="
						viewConfig()?.accountId
					"
					[theme]="themeMode()"
					[themeConfig]="resolvedThemeConfig()"
					[viewOnly]="viewOnly()"
					[reportDateRangeExpression]="reportDateRangeExpression()"
					(dateRangeChange)="onDateRangeChange($event)"
					(filterDateRangeChange)="filterDateRangeChange.emit($event)"
				>
				</jepto-page-container>
			</div>

			<div
				*ngIf="pages().length === 0 && !loading() && !error()"
				class="empty-state"
			>
				<p>No pages available to display</p>
			</div>
		</div>
	</jepto-page-editor>
</div>

<div class="theme-switch-floating" *ngIf="!captureMode()">
	<jepto-theme-switcher></jepto-theme-switcher>
</div>
